module.exports = __webpack_public_path__ + "static/media/Telegram-Desktop-screenshot.bdbf0c7d.png";